"use strict";

exports.__esModule = true;
exports.Condition = void 0;
var _core = require("@blueprintjs/core");
var _Selector = require("../../Core/Selector");
var _TranslatorContext = require("../../Core/Translator/TranslatorContext");
var _react = _interopRequireWildcard(require("react"));
var _CommonValidators = require("../utils/CommonValidators");
var _ClassificationSelector = require("../Common/ClassificationSelector");
var _DataItemTypeSelect = require("../Common/DataItemTypeSelect");
var _EnrichDefinitionContext = require("../EnrichDefinitionContext");
var _constants = require("../constants");
var _styles = require("./styles.js");
var _vimanaTypes = require("@vimana/vimana-types");
var _ConditionOperators = require("./ConditionOperators");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var Condition = exports.Condition = function Condition(_ref) {
  var _condition$conditionO, _condition$conditionB, _condition$conditionB2, _condition$conditionB3, _condition$conditionO2, _condition$conditionB4, _condition$conditionB5, _condition$conditionB6, _condition$conditionB7, _condition$conditionB8, _condition$conditionB9;
  var condition = _ref.condition,
    _updateSelf = _ref.updateSelf,
    _ref$first = _ref.first,
    first = _ref$first === void 0 ? false : _ref$first;
  var _useContext = (0, _react.useContext)(_TranslatorContext.TranslatorContext),
    translate = _useContext.translate;
  var _useContext2 = (0, _react.useContext)(_EnrichDefinitionContext.EnrichDefinitionContext),
    device = _useContext2.device,
    classifications = _useContext2.classifications,
    contextDataItems = _useContext2.dataItems;
  var names = classifications.map(function (classification) {
    return classification.name;
  });
  var oldClassificationNames = ["any"].concat(names);
  var _useState = (0, _react.useState)(false),
    isDataItem = _useState[0],
    setIsDataItem = _useState[1];
  var _useState2 = (0, _react.useState)([]),
    dataItemNames = _useState2[0],
    setDataItemNames = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    isGroup = _useState3[0],
    setIsGroup = _useState3[1];
  var dataItem = condition.dataItem,
    conditionOperation = condition.conditionOperation,
    value = condition.value,
    logicConnection = condition.logicConnection,
    conditionValue = condition.conditionValue;
  var operators = [];
  if (condition.conditionType === "CYCLE_CLASSIFY_TYPE") {
    operators = _ConditionOperators.CYCLE_OPERATORS;
  } else if (condition.conditionType === "USER_INPUT_TYPE") {
    operators = _ConditionOperators.USER_INPUT_OPERATORS;
  } else {
    operators = _ConditionOperators.CONDITION_OPERATORS;
  }
  (0, _react.useEffect)(function () {
    var _ref2;
    setIsDataItem(condition.conditionType === "DATA_ITEM_TYPE");
    setIsGroup(condition.conditionType === "GROUP_TYPE");
    if (isDataItem) setDataItemNames((_ref2 = (contextDataItems == null ? void 0 : contextDataItems.length) > 0 ? contextDataItems : device == null ? void 0 : device.dataItems) == null ? void 0 : _ref2.filter(function (item) {
      return (item == null ? void 0 : item.type) === (dataItem == null ? void 0 : dataItem.type);
    }).map(function (item) {
      return item == null ? void 0 : item.name;
    }));
  }, [dataItem]);
  var renderValueInput = function renderValueInput(conditionType) {
    switch (conditionType) {
      case "CYCLE_CLASSIFY_TYPE":
        return /*#__PURE__*/_react["default"].createElement(_ClassificationSelector.ClassificationSelector, {
          classificationName: condition.conditionValue,
          updateSelf: function updateSelf(self) {
            var updatedName = condition.conditionValue === (self == null ? void 0 : self.name) ? "" : self == null ? void 0 : self.name;
            _updateSelf(Object.assign({}, condition, {
              conditionValue: updatedName
            }));
          },
          isRequired: true,
          showText: false
        });
      default:
        if (!conditionValue && conditionType === "USER_INPUT_TYPE") _updateSelf(Object.assign({}, condition, {
          conditionValue: "empty"
        }));
        return /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({
          "data-testid": "EnrichEditorUI.Condition.InputValue"
        }, !(0, _CommonValidators.validateEmptyField)(conditionValue) && {
          intent: _core.Intent.DANGER
        }, {
          value: conditionType === "USER_INPUT_TYPE" ? "empty" : conditionValue,
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          disabled: conditionType === "USER_INPUT_TYPE",
          onChange: function onChange(_ref3) {
            var target = _ref3.target;
            return _updateSelf(Object.assign({}, condition, {
              conditionValue: target.value
            }));
          }
        }));
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_styles.ConditionRuleContainer, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, !first && /*#__PURE__*/_react["default"].createElement(_Selector.Selector, {
    dataTestId: "ConditionOrAnd",
    style: !(0, _CommonValidators.validateSelector)(logicConnection == null ? void 0 : logicConnection.value) ? {
      border: "solid 1px red",
      maxWidth: isGroup ? "100px" : "700px"
    } : {
      maxWidth: isGroup ? "100px" : "700px"
    },
    items: _constants.LogicalOperators,
    selected: logicConnection && [logicConnection],
    getKey: function getKey(operator) {
      return operator.value;
    },
    renderItemText: function renderItemText(operator) {
      return operator.displayName;
    },
    onSelect: function onSelect(_ref4) {
      var selected = _ref4[0];
      _updateSelf(Object.assign({}, condition, {
        logicConnection: selected
      }));
    },
    itemPredicate: function itemPredicate(query, item) {
      return item.value.toLowerCase().indexOf(query.toLowerCase()) !== -1 || item.displayName.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    }
  }), !isGroup ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isDataItem ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DataItemTypeSelect.DataItemTypeSelect, _extends({
    selected: dataItem && [dataItem],
    getKey: function getKey(item) {
      return item.type + "." + item.name;
    },
    renderItemText: function renderItemText(item) {
      return item.type;
    },
    renderItemLabel: function renderItemLabel(item) {
      return item.name;
    },
    placeholder: translate("EnrichEditorUI.Condition.DataItem.Type", "Data item"),
    onSelect: function onSelect(_ref5) {
      var selected = _ref5[0];
      _updateSelf(Object.assign({}, condition, {
        dataItem: selected
      }));
    }
  }, !(0, _CommonValidators.validateSelector)(dataItem == null ? void 0 : dataItem.type) && {
    style: Object.assign({}, true && {
      border: "solid 1px red"
    })
  })), /*#__PURE__*/_react["default"].createElement(_Selector.Selector, {
    dataTestId: "EnrichEditorUI.Condition.DataItem.Name",
    selected: (dataItem == null ? void 0 : dataItem.name) && [dataItem == null ? void 0 : dataItem.name],
    items: dataItemNames != null ? dataItemNames : [],
    getKey: function getKey(item) {
      return item;
    },
    renderItemText: function renderItemText(item) {
      return item;
    },
    onSelect: function onSelect(_ref6) {
      var selected = _ref6[0];
      var selectedDataItem = dataItem;
      selectedDataItem.name = selected;
      _updateSelf(Object.assign({}, condition, {
        dataItem: selectedDataItem
      }));
    },
    itemPredicate: function itemPredicate(query, item) {
      return item.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    }
  })) : null, !isDataItem ? ((_condition$conditionO = condition.conditionOperation) == null ? void 0 : _condition$conditionO.value) === "BETWEEN" ? /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
    dataTestId: "EnrichEditorUI.Condition.OldClassification",
    items: oldClassificationNames,
    selected: ((_condition$conditionB = condition.conditionBetween) == null ? void 0 : _condition$conditionB.old) && [(_condition$conditionB2 = condition.conditionBetween) == null ? void 0 : _condition$conditionB2.old],
    getKey: function getKey(name) {
      return name;
    },
    renderItemText: function renderItemText(name) {
      return name;
    },
    onSelect: function onSelect(_ref7) {
      var selected = _ref7[0];
      return _updateSelf(Object.assign({}, condition, {
        conditionBetween: Object.assign({}, condition.conditionBetween, {
          old: selected
        })
      }));
    }
  }, !(0, _CommonValidators.validateSelector)((_condition$conditionB3 = condition.conditionBetween) == null ? void 0 : _condition$conditionB3.old) && {
    style: Object.assign({}, true && {
      border: "solid 1px red"
    })
  })) : condition.conditionType !== "CYCLE_CLASSIFY_TYPE" ? /*#__PURE__*/_react["default"].createElement(_core.InputGroup, {
    "data-testid": "EnrichEditorUI.Condition.FreeTextInput",
    value: value,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onChange: function onChange(_ref8) {
      var target = _ref8.target;
      return _updateSelf(Object.assign({}, condition, {
        value: target.value
      }));
    }
  }) : /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      margin: "auto",
      textAlign: "center"
    }
  }, translate("EnrichEditorUI.Condition.CurrentClassification", "Current Classification") + " ") : null, !(condition.conditionType === "MESSAGE_TYPE" || condition.conditionType === "CONDITION_TYPE") && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
    dataTestId: "EnrichEditorUI.Condition.Operators"
  }, !(0, _CommonValidators.validateSelector)(conditionOperation == null ? void 0 : conditionOperation.value) && {
    style: Object.assign({}, true && {
      border: "solid 1px red"
    })
  }, {
    items: operators,
    selected: conditionOperation && [conditionOperation],
    getKey: function getKey(operator) {
      return operator.value;
    },
    renderItemText: function renderItemText(operator) {
      return operator.displayName;
    },
    placeholder: translate("EnrichEditorUI.Condition.ConditionOperator", "Operator"),
    onSelect: function onSelect(_ref9) {
      var selected = _ref9[0];
      _updateSelf(Object.assign({}, condition, {
        conditionOperation: selected
      }));
    },
    itemPredicate: function itemPredicate(query, item) {
      return item.value.toLowerCase().indexOf(query.toLowerCase()) !== -1 || item.displayName.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    }
  })), ((_condition$conditionO2 = condition.conditionOperation) == null ? void 0 : _condition$conditionO2.value) === "BETWEEN" ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
    dataTestId: "ClassificationBetweenFirstSelector",
    items: names,
    selected: ((_condition$conditionB4 = condition.conditionBetween) == null ? void 0 : _condition$conditionB4.from) && [(_condition$conditionB5 = condition.conditionBetween) == null ? void 0 : _condition$conditionB5.from],
    getKey: function getKey(name) {
      return name;
    },
    renderItemText: function renderItemText(name) {
      return name;
    },
    onSelect: function onSelect(_ref0) {
      var selected = _ref0[0];
      return _updateSelf(Object.assign({}, condition, {
        conditionBetween: Object.assign({}, condition.conditionBetween, {
          from: selected
        })
      }));
    }
  }, !(0, _CommonValidators.validateSelector)((_condition$conditionB6 = condition.conditionBetween) == null ? void 0 : _condition$conditionB6.from) && {
    style: Object.assign({}, true && {
      border: "solid 1px red"
    })
  })), /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
    dataTestId: "EnrichEditorUI.Condition.ClassificationBetween.SecondSelector",
    items: names,
    selected: ((_condition$conditionB7 = condition.conditionBetween) == null ? void 0 : _condition$conditionB7.to) && [(_condition$conditionB8 = condition.conditionBetween) == null ? void 0 : _condition$conditionB8.to],
    getKey: function getKey(name) {
      return name;
    },
    renderItemText: function renderItemText(name) {
      return name;
    },
    onSelect: function onSelect(_ref1) {
      var selected = _ref1[0];
      return _updateSelf(Object.assign({}, condition, {
        conditionBetween: Object.assign({}, condition.conditionBetween, {
          to: selected
        })
      }));
    }
  }, !(0, _CommonValidators.validateSelector)((_condition$conditionB9 = condition.conditionBetween) == null ? void 0 : _condition$conditionB9.to) && {
    style: Object.assign({}, true && {
      border: "solid 1px red"
    })
  }))) : renderValueInput(condition.conditionType)), " ") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, translate("EnrichEditorUI.Condition.Group.name", "Compound")));
};